import React from 'react';
import PropTypes from 'prop-types';

import { Typography, Box, Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const colors = {
	secondaryTextColor: 'white',
	errorColor: '#d0021b'
};

const useStyles = makeStyles(() => ({
	mainContentStyle: {
		maxWidth: 500
	},
	title: {
		fontWeight: 'bold'
	},
	container: {
		backgroundColor: colors.secondaryTextColor,
		width: '100%',
		height: '100vh'
	},
	message: {
		fontWeight: 'bold',
		textAlign: 'center'
	}
}));

const ErrorComponent = ({
	title = 'PAGE NOT FOUND',
	message = 'Sorry, the link you were following is probably broken or the page has been removed.',
	imageUrl = 'https://static.goalsmapper.com/public/platform/empty_state/page_not_found.png'
}) => {
	const classes = useStyles();

	return (
		<Container maxWidth="md">
			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				flexDirection="column"
				className={classes.container}
			>
				<Typography variant="h4" className={classes.title} color="textPrimary" gutterBottom>
					{title}
				</Typography>
				<img src={imageUrl} width={500} alt={title} />
				<Box pt={4} px={3}>
					<Typography
						variant="subtitle1"
						className={classes.message}
						color="textSecondary"
						gutterBottom
					>
						{/* eslint-disable-next-line react/no-danger */}
						<div dangerouslySetInnerHTML={{ __html: message }} />
					</Typography>
				</Box>
			</Box>
		</Container>
	);
};

ErrorComponent.propTypes = {
	title: PropTypes.string,
	message: PropTypes.string,
	imageUrl: PropTypes.string
};

export default ErrorComponent;
